const MR = 'MR';
const MS = 'MS';
const DR = 'DR';
const PROFESSOR = 'PROFESSOR';

const titlesMap = {
  [MR]: { id: 'General.title.Mr', defaultMessage: '** Mr.' },
  [MS]: { id: 'General.title.Ms', defaultMessage: '** Ms.' },
  [DR]: { id: 'General.title.Dr', defaultMessage: '** Dr.' },
  [PROFESSOR]: { id: 'General.title.Prof', defaultMessage: '** Prof.' },
};

const firstLetter = str => {
  // Char Code 8207 is empty char which indicate rtl of str;
  if (!str) return ' ';
  if (str.charCodeAt(0) === 8207) {
    return str[1];
  }
  return str[0];
};

export const getUserInitials = ({ firstName, lastName }) => `${ firstLetter(firstName) }${ firstLetter(lastName) }`.toUpperCase();

export const getTranslatedUserTitle = (title) => {
  return titlesMap[title] ? titlesMap[title] : null;
};

export const getUserFullName = ({ title, firstName, lastName }) => {
  const titleMapped = getTranslatedUserTitle(title);

  return (
    `${ titleMapped && window.intl ? window.intl.formatMessage(getTranslatedUserTitle(title)) : '' } ${ firstName || '' } ${ lastName || '' }`.trim()
  );
};

export const getUserFullNameWithMiddleName = ({ title, firstName, lastName, middleName }) => {
  const titleMapped = getTranslatedUserTitle(title);

  return (
    `${ titleMapped ? window.intl.formatMessage(titleMapped) : '' } ${ firstName || '' } ${ middleName || '' } ${ lastName || '' }`.trim()
  );
};
